<template>
  <div v-loading="dataLoading" class="account-supplement">
    <rhcn-drawer :showClose="showClose" @on-close="onClose">
      <template slot="title">
        <div class="supplement-step-box">
          <rhcn-step :steps="steps" :active="active"></rhcn-step>
        </div>
      </template>
      <template slot="headerRight"> </template>
      <div class="form">
        <template v-if="supplementStep === 0">
          <supplement-step1 @finish="handleNext"></supplement-step1>
        </template>
        <template v-else-if="supplementStep === 1">
          <supplement-step2 @finish="handleNext(1, $event)"></supplement-step2>
        </template>
        <template v-else-if="supplementStep === 2">
          <supplement-step3
            :quickRegistration="quickRegistration"
            :merchantNo="merchantNo"
            :serviceType="serviceType"
            :supplementInfo="supplementInfo"
            :errorMessage="errorMessage"
            @finish="handleNext"></supplement-step3>
        </template>
        <template v-else-if="supplementStep === 3">
          <supplement-step4 :isError="!!tipText" :tips="tipText" @edit="updateInfo"></supplement-step4>
        </template>
      </div>
    </rhcn-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getUserInformation } from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import RhcnStep from '@/components/step/index.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getFileNameFromUrl } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import SupplementStep1 from '@/views/account/information/supplement/step1/index.vue';
import SupplementStep2 from '@/views/account/information/supplement/step2/index.vue';
import SupplementStep3 from '@/views/account/information/supplement/step3/index.vue';
import SupplementStep4 from '@/views/account/information/supplement/step4/index.vue';

export default {
  components: {
    RhcnDrawer,
    RhcnStep,
    SupplementStep1,
    SupplementStep2,
    SupplementStep3,
    SupplementStep4,
  },
  data() {
    return {
      steps: [
        {
          title: 'message.user.register',
        },
        {
          title: 'message.user.supplement',
        },
        {
          title: 'message.user.approving',
        },
        {
          title: 'message.common.finish',
        },
      ],
      active: 1,
      supplementStep: 0,
      serviceType: '0',
      dataLoading: false,
      tipText: '',
      merchantNo: '',
      showClose: false,
      quickRegistration: false,
      supplementInfo: {},
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      const { type, businessType } = this.$route.query;
      if (`${type}` === '1') { // 快速注册
        this.supplementStep = 1;
        this.showClose = true;
        this.serviceType = businessType;
        this.quickRegistration = true;
        return;
      }
      this.dataLoading = true;
      if (this.app.userLogin.merchantNo) {
        try {
          const res = await AccountInfo.getAccountInfo();
          if (res.auditStatus === 'waiting' || res.auditStatus === 'processing') {
            // 待审核、审核中
            this.active = 2;
            this.supplementStep = 3;
          } else if (res.auditStatus === 'fail') { // 审核不通过
            this.active = 3;
            this.supplementStep = 3;
            this.tipText = res.auditComments;
            this.errorMessage = res.auditComments;
          } else {
            this.$router.replace({ path: '/user/login' });
          }

          if (res.profile) {
            const profile = JSON.parse(res.profile);
            this.serviceType = profile.businessType;
            this.merchantNo = res.merchantNo;
          }
        } catch (err) {

        }
      }
      this.dataLoading = false;
    },
    handleNext(index, value) {
      if (index === 1) {
        this.serviceType = value;
      }
      this.supplementStep += 1;
      if (this.supplementStep === 3) {
        this.active = 2;
        this.tipText = '';
      }
    },
    async updateInfo() {
      this.dataLoading = true;
      try {
        const res = await getUserInformation();
        const info = JSON.parse(res);
        if (info.materialList && info.materialList.length > 0) {
          const dict = await GlobalData.getDictList(['MATERIAL_NAME']);
          const materialNameUrlList = initSelectedData(dict.MATERIAL_NAME);
          info.materialList = info.materialList.map(item => {
            const fileUrl = item.fileUrl;
            const fileList = [];
            if (`${item.materialFormat}` !== '2' && item.fileUrl) {
              fileList.push({
                name: getFileNameFromUrl(item.fileUrl),
                url: item.fileUrl,
              });
            }
            return {
              ...item,
              label: `${getEnantiomericValue(materialNameUrlList, item.materialName)}${item.required ? '' : `(${this.$t('message.common.optional')})`}`,
              accept: item.materialFormat === '1' ? 'image/png,image/jpeg,image/jpg' : '',
              fileUrl,
              fileList,
            };
          });
        }
        if (info.shareholderInfoList && info.shareholderInfoList.length > 0) {
          info.shareholderInfoList = info.shareholderInfoList.map(item => {
            const idCardFrontList = [];
            const idCardReverseList = [];
            if (item.idCardFront) {
              idCardFrontList.push({
                name: getFileNameFromUrl(item.idCardFront),
                url: item.idCardFront,
              });
            }
            if (item.idCardReverse) {
              idCardReverseList.push({
                name: getFileNameFromUrl(item.idCardReverse),
                url: item.idCardReverse,
              });
            }
            return {
              ...item,
              idCardFrontList,
              idCardReverseList,
            };
          });
        }
        this.supplementInfo = info;
        this.active = 1;
        this.supplementStep = 2;
      } catch (err) {

      }
      this.dataLoading = false;
    },
    onClose() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/element-variables.scss';

.account-supplement {
  .drawer-form-wrapper .form {
    width: 450px;
  }

  .supplement-step-box {
    width: 580px;
    margin: 0 auto;
  }
}
</style>
